var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInsurance = function SvgInsurance(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-72": 52,
    viewBox: "0 0 11.7 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h4.275a1.5 1.5 0 0 1 1.068.446l2.39 2.421c.278.28.434.66.434 1.054v1.912a.5.5 0 1 0 1 0V4.921a2.5 2.5 0 0 0-.722-1.757L8.555.744l-.357.35.356-.35A2.5 2.5 0 0 0 6.775 0H2.5A2.5 2.5 0 0 0 0 2.5v8A2.5 2.5 0 0 0 2.5 13h2.333a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 1 1 10.5zM3.003 7h2.83a.5.5 0 1 0 0-1h-2.83a.5.5 0 0 0 0 1m1.164 2.333H3.003a.5.5 0 1 1 0-1h1.164a.5.5 0 0 1 0 1m5.598-.05a.4.4 0 1 0-.566-.566l-.915.914-.336-.333a.4.4 0 1 0-.563.569l.62.613a.4.4 0 0 0 .564-.001zm-1.543-3.07a.4.4 0 0 1 .556 0l2.667 2.586a.4.4 0 0 1-.378.674v2.36a.4.4 0 0 1-.4.4H6.333a.4.4 0 0 1-.4-.4v-2.36a.4.4 0 0 1-.378-.674zM6.733 8.77v2.663h3.534V8.77L8.5 7.057zM2.994 3.833a.5.5 0 1 0 0 1h5.33a.5.5 0 1 0 0-1z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsurance);
export default ForwardRef;